import ClassHelper from '../ClassHelper';
import Account from '../account/Account';
import DateTZ from '../date/DateTZ';
import Order from '../order/Order';
import Point from '../point/Point';
import Subdivision from '../subdivision/Subdivision';
import User from '../user/User';
import PaymentDetails from './PaymentDetails';

class BillTransaction extends ClassHelper {
  constructor({ account, cashier, initiator, partner, user, accountReceiver, order, subdivision, point, date, paymentMethod, description,
    amount, type, status, paymentDetails, commissionIncome, commissionSystem, receiptSent, meta
  } = {}) {
    super(...arguments);
    this.account = this.ref(account, Account);
    this.initiator = this.obj(initiator, User);
    this.cashier = this.obj(cashier, User);
    this.partner = this.obj(partner, Account);
    this.accountReceiver = this.obj(accountReceiver, Account);
    this.user = this.obj(user, User);
    this.order = this.ref(order, Order);
    this.subdivision = this.ref(subdivision, Subdivision);
    this.point = this.ref(point, Point);
    this.date = this.obj(date, DateTZ);
    this.receiptSent = !!receiptSent;
    this.paymentMethod = paymentMethod; // PaymentMethod
    this.description = description;
    this.amount = amount;
    this.type = type; // BillTransactionType
    this.status = status; //BillTransactionStatus
    this.paymentDetails = this.obj(paymentDetails, PaymentDetails);
    this.commissionIncome = commissionIncome;
    this.commissionSystem = commissionSystem;
    this.meta = meta;
  }
}

export default BillTransaction;